import _ from 'lodash';
import APIClient from './index';

const catalogErrorMessage = error => _.get(error, 'response.data.error') || _.get(error, 'message') || 'Catalog request failed.';

export const getCatalogBrands = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogWorkspace = (brandKey, BrandIntegration_id = null) => {
  return new Promise((resolve, reject) => {
    const query = BrandIntegration_id ? `?${new URLSearchParams({ BrandIntegration_id }).toString()}` : '';
    APIClient.get(`Catalogs/brands/${brandKey}${query}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const pullCatalogBrandSnapshot = (brandKey, BrandIntegration_id) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`Catalogs/brands/${brandKey}/snapshot`, { BrandIntegration_id })
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const uploadCatalogScript = (brandKey, BrandIntegration_id, content) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`Catalogs/brands/${brandKey}/scripts`, { BrandIntegration_id, content })
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const renameCatalogScript = (brandKey, BrandIntegration_id, fingerprint, name) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`Catalogs/brands/${brandKey}/scripts/${fingerprint}`, { BrandIntegration_id, name })
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const createCatalogRun = (brandKey, { BrandIntegration_id, mode = 'custom', snapshotFingerprint, scriptFingerprint, autoPublish = false }) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`Catalogs/brands/${brandKey}/runs`, { BrandIntegration_id, mode, snapshotFingerprint, scriptFingerprint, autoPublish })
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogArtifacts = (brandKey, BrandIntegration_id) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands/${brandKey}/artifacts?${new URLSearchParams({ BrandIntegration_id }).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogSnapshotArtifact = (brandKey, BrandIntegration_id, fingerprint) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands/${brandKey}/snapshots/${fingerprint}/artifact?${new URLSearchParams({ BrandIntegration_id }).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogScriptArtifact = (brandKey, BrandIntegration_id, fingerprint) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands/${brandKey}/scripts/${fingerprint}/artifact?${new URLSearchParams({ BrandIntegration_id }).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogRunArtifact = (brandKey, BrandIntegration_id, Run_id, kind) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands/${brandKey}/runs/id/${Run_id}/artifact?${new URLSearchParams({ BrandIntegration_id, kind }).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const publishCatalogRun = (brandKey, BrandIntegration_id, Run_id = null, overrides = []) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`Catalogs/brands/${brandKey}/publish`, { BrandIntegration_id, ...(Run_id ? { Run_id } : {}), overrides })
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogPublishImpact = (brandKey, BrandIntegration_id, Run_id = null) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands/${brandKey}/publish-impact?${new URLSearchParams({ BrandIntegration_id, ...(Run_id ? { Run_id } : {}) }).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogRuns = (brandKey, BrandIntegration_id, number = null) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands/${brandKey}/runs?${new URLSearchParams({ BrandIntegration_id, ...(number != null ? { number } : {}) }).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogComparePairs = (brandKey, params) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands/${brandKey}/compare/variants?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogComparePairDetail = (brandKey, BrandIntegration_id, variantKey, Run_id = null) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands/${brandKey}/compare/variants/${variantKey}?${new URLSearchParams({ BrandIntegration_id, ...(Run_id ? { Run_id } : {}) }).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogVariants = (brandKey, params) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands/${brandKey}/variants?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};

export const getCatalogVariant = (brandKey, BrandIntegration_id, variantKey) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Catalogs/brands/${brandKey}/variants/${variantKey}?${new URLSearchParams({ BrandIntegration_id }).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(catalogErrorMessage(error)));
  });
};
